import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useSnackbar } from "notistack";
import { translate } from "../../translations/index.js";
import { ChangeEvent, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import APIclient from "../../api-client/index.js";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  async function resetPassword() {
    setErrorMessage("");
    if (passwordConfirmation !== password) {
      setErrorMessage(
        translate("auth.resetPassword.edit.noMatchingPasswords")!,
      );
      return;
    }

    try {
      await APIclient.auth.passwords.update(
        searchParams.get("token")!,
        password,
      );
    } catch {
      setErrorMessage(translate("auth.resetPassword.edit.genericError")!);
      return;
    }
    enqueueSnackbar(translate("auth.resetPassword.edit.successMessage"), {
      variant: "success",
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
    navigate("/login");
  }

  return (
    <div className="container container--max-xs">
      <h1>{translate("auth.resetPassword.edit.title")}</h1>
      <ValidatorForm
        onSubmit={() => resetPassword()}
        // eslint-disable-next-line no-console
        onError={(errors) => console.log(errors)}
      >
        <TextValidator
          name="password"
          label={translate("auth.resetPassword.edit.password.label")}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setPassword(e.target.value)
          }
          value={password}
          fullWidth
          className="normal-input"
          type="password"
          validators={["required"]}
          errorMessages={[translate("form_validation_required")]}
        />
        <TextValidator
          name="confirm-password"
          label={translate("auth.resetPassword.edit.confirmPassword.label")}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setPasswordConfirmation(e.target.value)
          }
          value={passwordConfirmation}
          fullWidth
          className="normal-input"
          validators={["required"]}
          type="password"
          errorMessages={[translate("form_validation_required")]}
        />
        <button className="button" type="submit">
          {translate("auth.resetPassword.edit.submit")}
        </button>
      </ValidatorForm>
      {errorMessage.length > 0 && (
        <p style={{ color: "red" }}>{errorMessage}</p>
      )}
    </div>
  );
}
